import { render, staticRenderFns } from "./barchart_horizontal_component.vue?vue&type=template&id=83f8b28e"
import script from "./barchart_horizontal_component.vue?vue&type=script&lang=js"
export * from "./barchart_horizontal_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports